import { CraftingResources } from '@components/arsenal/forge/CraftingResources';
import { EquipmentDisplay } from '@components/helpers/EquipmentDisplay';
import { CraftingTimer } from '@components/arsenal/forge/CraftingTimer';
import { ChassisInfo } from '@components/arsenal/chassis/ChassisInfo';
import { capitalize } from '@helpers/dotNotation';
import { Modal } from '@components/ui/Modal';
import * as Shared from '@shared/lib';
import { useState } from 'react';

interface ChassisCraftingProps {
  chassis: string;
  finishesAt?: string;
}

export function ChassisCrafting({ chassis, finishesAt }: ChassisCraftingProps) {
  const [showInfo, setShowInfo] = useState(false);

  const data = Shared.chassisData.find((c) => c.key === chassis);
  if (!data) return null;

  const crafting = data.crafting;

  return (
    <>
      <Modal
        onRequestClose={() => setShowInfo(false)}
        title={capitalize(data.key)}
        isOpen={showInfo}
      >
        <ChassisInfo chassis={data.key} />
      </Modal>

      <EquipmentDisplay onClick={() => setShowInfo(true)} value={data.key} type="CHASSIS">
        {finishesAt && <CraftingTimer duration={crafting.duration} finishesAt={finishesAt} />}
        {!finishesAt && <CraftingResources crafting={crafting} />}
      </EquipmentDisplay>
    </>
  );
}